import store from "data/store";
import { Flex, List } from "antd";
import React, { Component } from "react";
import ChatCard from "components/cards/chat";
import { Observer, observer } from "mobx-react";
import ChatsService from "services/chats";

class ChatsPage extends Component {
  render() {
    return (
      <Flex style={{ flex: 1 }} vertical>
        <List
          dataSource={store.chats.items.toJSON()}
          renderItem={(chat, index) => (
            <Observer>
              {() => (
                <>
                  <ChatCard
                    number={index + 1}
                    key={chat.id}
                    name={chat.contact.firstName || `User #${chat.contact.id}`}
                    onClick={() => ChatsService.selectChat(chat.id)}
                    active={store.activeChat?.id === chat.id}
                    unreadMessagesCount={chat.unreadMessagesCount}
                    lastMessage={chat.lastMessage}
                    startedAt={chat.startedAt}
                    beDestroyedAt={chat.beDestroyedAt}
                    isTyping={chat.isTyping}
                    isOnline={chat.isOnline}
                    isTrial={chat.isTrial}
                    paidMinutes={chat.paidMinutes}
                    tag={chat.tag}
                  />
                </>
              )}
            </Observer>
          )}
        />
      </Flex>
    );
  }
}

export default observer(ChatsPage);
